'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Effect = undefined;

var _NotificationBadge = require('./components/NotificationBadge');

var _NotificationBadge2 = _interopRequireDefault(_NotificationBadge);

var _Effect = require('./components/Effect');

var _Effect2 = _interopRequireDefault(_Effect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotificationBadge2.default;
exports.Effect = _Effect2.default;


// WEBPACK FOOTER //
// ../~/react-notification-badge/lib/index.js